import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TagModule } from 'primeng/tag';
import { buildPublicExperienceStyles } from '../../../services/global.service';
import { ProductDesignTemplatePageModuleDataContent } from '../../../store/app.model';

@Component({
  selector: 'app-attributes',
  imports: [CommonModule, TagModule],
  templateUrl: './attributes.component.html',
})
export class AttributesComponent implements OnChanges {
  // @Input({ required: true }) content!: ProductDesignTemplatePageContent;
  @Input({ required: true }) content!: any;
  @Input({ required: true }) styles!: any;
  @Input({ required: true }) isSelectedModule!: boolean;
  @Input({ required: true }) isFirstModule!: boolean;
  @Input({ required: true }) isLastModule!: boolean;

  items: ProductDesignTemplatePageModuleDataContent[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (this.content) {
      if (
        'pageModuleTemplateDataContents' in this.content &&
        Array.isArray(this.content.pageModuleTemplateDataContents)
      ) {
        this.items = this.content.pageModuleTemplateDataContents;
      } else if (
        'contentItems' in this.content &&
        Array.isArray(this.content.contentItems)
      ) {
        this.items = this.content.contentItems;
      } else if (
        'components' in this.content &&
        Array.isArray(this.content.components)
      ) {
        this.items = this.content.components;
      } else {
        this.items = [];
      }
    } else {
      this.items = [];
    }
  }

  filter(array: any[] | undefined | null, column: any, value: any) {
    if (!array) return [];
    return array.filter(item => item[column] === value);
  }

  buildStyle(type: string, style: any): string {
    return buildPublicExperienceStyles(type, style);
  }
}
